import { ReactNode } from 'react';
import { FEATURE_FLAGS, FeatureFlag } from 'src/shared/constants/featureFlags.constant';
import { useOrg } from 'src/shared/contexts/OrgContext';
import { useFeatureFlag } from 'src/shared/queries/utils/useFeatureFlag';
import { Role } from 'src/shared/types/organisation.types';

interface FeatureFlagProps {
  flag: FeatureFlag;
  allowedRoles?: Role[];
  not?: boolean;
  children: ReactNode;
  fallback?: ReactNode;
}

function WithFeatureFlag({ children, flag, not, fallback, allowedRoles }: FeatureFlagProps) {
  const { featureFlags, role } = useOrg();
  useFeatureFlag(flag);

  const hasAccess =
    featureFlags !== null &&
    ((not ? !featureFlags.has(FEATURE_FLAGS[flag]) : featureFlags.has(FEATURE_FLAGS[flag])) ||
      (allowedRoles ? allowedRoles.includes(role) : false));

  if (hasAccess) {
    return children;
  }

  return fallback || null;
}

export default WithFeatureFlag;
